import React from 'react'
import LoadingSpinner from './LoadingSpinner'

export default function MainButton({loading, handleClick, title}) {
  return (
    <button disabled={loading} onClick={handleClick} className="btn theme-btn profile-button btn-sm" type="button">{loading && <LoadingSpinner /> }{ title }</button>
  )
}
